export default __webpack_public_path__ + "locales/de/SMTPSettings.json?hash=d6ea1742aa70a51bf2935a866c29eb99";